import React from "react"

import { GenericWriteForm } from "QuorumGrassroots/campaign-forms/components/ReusableForms/GenericWriteForm"

export const WriteWhiteHouseForm = (props) => <GenericWriteForm {...props} />
